import { useDispatch } from 'react-redux';
export const useAction = (type) => {
    const dispatch = useDispatch();
    return (payload) => dispatch({ type, payload });
};
//# sourceMappingURL=useAction.js.map